export function SpeedKmh({ speed }) {
  if (speed === undefined) return <>-</>;
  return <>{speed} km/h</>;
}
